import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Page_header extends Component {

    render() {

        let HeaderTitle = this.props.headertitle;
        let publicUrl = process.env.PUBLIC_URL+'/'
        let Subheader = this.props.subheader ? this.props.subheader : HeaderTitle

        return (

		<div className="breadcrumb-area bg-overlay-2" style={{backgroundImage: 'url("'+publicUrl+'assets/img/1.jpg")'}}>
		  <div className="container">
		    <div className="breadcrumb-inner">
		      <div className="section-title">
		        <h4 className="page-title">{ HeaderTitle }</h4>
		        <p>Työpajankatu 6 A , 00580 Helsinki</p>
		      </div>
		    </div>
		  </div>
		</div>



        )
    }
}


export default Page_header